<app-header [isMobile]="isMobile" (toggleSidenav)="sidenav.toggle()"></app-header>
<mat-sidenav-container [hasBackdrop]="isMobile ? true : false">
    <!-- On a phone the menu slides over the page and runs from the header to the bottom of the screen. -->
    <mat-sidenav #sidenav [mode]="isMobile ? 'over' : 'side'" [opened]="isMobile ? false : true"
        [class.mobile-drawer]="isMobile" [fixedInViewport]="true" [fixedTopGap]="50" [fixedBottomGap]="isMobile ? 0 : 47">
        <app-sidenav (closeSidenav)="sidenav.close()"></app-sidenav>
    </mat-sidenav>
    <!--SIDENAV: -->
    <mat-sidenav-content style="margin-left:90px">
        <!-- <mat-sidenav-content style="margin-left:66px"> -->
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>

<!-- The floating chat window: one for the whole app, outside the sidenav container so it survives page changes
     (tasks/messaging-hub-architecture.md M1). The header icon and the sidenav item toggle it. -->
<app-chat-window></app-chat-window>
